module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/treasury_separator.c0d3ae8b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/treasury_separator.png
// module id = 3045
// module chunks = 11